import Cookies from "js-cookie";

/** Hook to determine if user is from SG or not. */
export const useCountry = () => {
  if (typeof window === "undefined") return { isSGUser: true };

  const cookie = Cookies.get("sph_user_country");
  if (typeof cookie === "undefined") return { isSGUser: true };

  const isSGUser = cookie === "SG";

  return { isSGUser };
};
